import builder from '../builder';
import CheckCircleAlternate from '../../streamline-icons/bold/check-circle-alternate.svg';

export default builder('IconCheckCircleAlternateBold', CheckCircleAlternate);
